import React from "react";
import Footer from "../../components/Footer";
import Phd from "../../components/Phd";
import NavBar from "../../components/navbar/NavBar";

const PhdPage = () => {
  return (
    <div>
      <NavBar />
      <Phd />
      <Footer />
    </div>
  );
};

export default PhdPage;
